

import { Auth } from "@cleeng/mediastore-sdk";
import React from "react";
import LogoutIcon from "../icons/Logout"
import { useNavigate } from "react-router-dom";

function Logout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("CLEENG_CUSTOMER_ID")
    localStorage.removeItem("CLEENG_REFRESH_TOKEN")
    localStorage.removeItem("CLEENG_CUSTOMER_EMAIL")
    localStorage.removeItem("CLEENG_AUTH_TOKEN")

    navigate("/")
  }
  return (
    <>
      {Auth.isLogged() && <div className="logout" onClick={handleLogout}>
        <LogoutIcon />
      </div>}
    </>
  );
}

export default Logout;